var _defs, _path, _circle, _path2, _circle2, _rect, _circle3, _rect2, _circle4, _rect3, _circle5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftGraph(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_1left",
    "data-name": "1left",
    xmlns: "http://www.w3.org/2000/svg",
    width: 260,
    height: 517,
    viewBox: "0 -50 260 517",
    preserveAspectRatio: "xMidYMin meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .home-bg-left-cls-1, .home-bg-left-cls-5 {\n        fill: #d4c527;\n        opacity: 0.5;\n      }\n\n      .home-bg-left-cls-1, .home-bg-left-cls-3 {\n        fill-rule: evenodd;\n      }\n\n      .home-bg-left-cls-2 {\n        fill: #ee162d;\n      }\n\n      .home-bg-left-cls-3 {\n        fill: #fbc5ca;\n      }\n\n      .home-bg-left-cls-4, .home-bg-left-cls-6 {\n        fill: #424143;\n      }\n\n      .home-bg-left-cls-6 {\n        opacity: 0.25;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_8",
    "data-name": "Rectangle 2 copy 8",
    className: "home-bg-left-cls-1",
    d: "M932,1551H886v-8h46a37,37,0,0,0,0-74H697v-8H932a45,45,0,0,1,45,45h0A45,45,0,0,1,932,1551Z",
    transform: "translate(-717 -1084)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_10",
    "data-name": "Ellipse 1 copy 10",
    className: "home-bg-left-cls-2",
    cx: 169,
    cy: 463,
    r: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_12",
    "data-name": "Rectangle 2 copy 12",
    className: "home-bg-left-cls-3",
    d: "M802.725,1235a19.889,19.889,0,0,0-19.78,19.99H783A20.006,20.006,0,0,0,803,1275h36a25,25,0,0,1,0,50H697v-5H839a20,20,0,0,0,0-40H803a25,25,0,0,1-25-25h0v-0.01h0A24.863,24.863,0,0,1,802.725,1230H913v5H802.725Z",
    transform: "translate(-717 -1084)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_17",
    "data-name": "Ellipse 1 copy 17",
    className: "home-bg-left-cls-2",
    cx: 196.5,
    cy: 148.5,
    r: 2.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "home-bg-left-cls-4",
    x: -20,
    y: 313,
    width: 218,
    height: 10
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_6",
    "data-name": "Ellipse 1 copy 6",
    className: "home-bg-left-cls-2",
    cx: 198,
    cy: 318,
    r: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3_copy_3",
    "data-name": "Rectangle 3 copy 3",
    className: "home-bg-left-cls-5",
    x: -20,
    width: 221,
    height: 8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_12",
    "data-name": "Ellipse 1 copy 12",
    className: "home-bg-left-cls-2",
    cx: 201,
    cy: 4,
    r: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3_copy_2",
    "data-name": "Rectangle 3 copy 2",
    className: "home-bg-left-cls-6",
    x: -20,
    y: 81,
    width: 130,
    height: 5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_9",
    "data-name": "Ellipse 1 copy 9",
    className: "home-bg-left-cls-2",
    cx: 109.5,
    cy: 83.5,
    r: 2.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftGraph);
export default __webpack_public_path__ + "static/media/left-graph.1aaff3030354c35257d125f29617679d.svg";
export { ForwardRef as ReactComponent };